import { Box, Paper, Tab, Typography } from "@mui/material";
import { useState } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import FeedbackList, { FeedbackListSkeleton } from "../FeecbackList";
import { getEmployeeId, getUserData } from "../../../../Base/helper/baseFunctions";
import { useDispatch } from "react-redux";
import { UpdatePmsFeedbackAction } from "../../../../../../store/Employee/PMSFeedback/Action";

const MyFeedback = ({
  feedbackData,
  getTypeColor,
  handleFeedbackPopup,
  pmsFeedbackLoading,
}) => {
  const [value, setValue] = useState("1");
    const dispatch = useDispatch();
      const userData = getUserData();
      const today = new Date();
        const [replyLoading, setReplyLoading] = useState(true);
      
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleReplyAdd = (feedback, replyMsg) => {
      if(feedback?.feedback_pk) {
        setReplyLoading(false);
        dispatch(
            UpdatePmsFeedbackAction({...feedback,
              replyToast: true,
              feedback_type: {value: feedback?.feedback_type},
              feedback_json: JSON.stringify([
                {
                  from: userData?.name,
                  message: replyMsg,
                  date: `${today.getFullYear()}-${("0" + (today.getMonth() + 1)).slice(-2)}-${("0" + today.getDate()).slice(-2)}`,
                },
               ...(
                  Array.isArray(feedback?.feedback_json) 
                    ? feedback.feedback_json 
                    : typeof feedback?.feedback_json === "string" 
                      ? JSON.parse(feedback.feedback_json) 
                      : []
                ),
            ]),
            }, (error, result) => {
              setReplyLoading(true);
            })
          );
      }
    }
  return (
    <Box>
      <Paper sx={{ borderRadius: "10px", minHeight: "87vh" }}>
        <Box sx={{ width: "100%" }}>
          <TabContext value={value}>
            <Box>
              <TabList
                sx={{
                  minHeight: "40px",
                  ".MuiTab-root": { minHeight: "20px" },
                  "& .MuiTabs-indicator": {
                    width: "100%",
                    display: "flex",
                    justifyContent: "center !important",
                  },
                }}
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Feedback I Received " value="1" />
                <Tab label="Feedback I Gave " value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" sx={{ padding: "0px", height: "calc(100vh - 190px)", overflowY: "auto" }}>
              {(pmsFeedbackLoading && replyLoading) ? (
                Array.from(new Array(3)).map((_, idx) => (
                  <FeedbackListSkeleton />
                ))
              ) : feedbackData?.filter(el => +el?.feedback_to === getEmployeeId())?.length > 0 ? (
                <FeedbackList
                  feedbacks={feedbackData?.filter(el => +el?.feedback_to === getEmployeeId())}
                  getTypeColor={getTypeColor}
                  onReply={(fb, replyMsg) => handleReplyAdd(fb, replyMsg)}
                  handleFeedbackPopup={handleFeedbackPopup}
                  feedbackType={"Received"}
                />
              ) : (
                <Box
                  sx={{
                    height: "40vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h6"
                    color="text.secondary"
                    sx={{ textAlign: "center", px: 2 }}
                  >
                    No Data Available
                  </Typography>
                </Box>
              )}
            </TabPanel>
            <TabPanel value="2" sx={{ padding: "0px", height: "calc(100vh - 190px)", overflowY: "auto" }}>
              {(pmsFeedbackLoading && replyLoading) ? (
                Array.from(new Array(3)).map((_, idx) => (
                  <FeedbackListSkeleton />
                ))
              ) : feedbackData?.filter(el => +el?.feedback_from === getEmployeeId())?.length > 0 ? (
                <FeedbackList
                  feedbacks={feedbackData?.filter(el => +el?.feedback_from === getEmployeeId())}
                  getTypeColor={getTypeColor}
                  onReply={(fb, replyMsg) => handleReplyAdd(fb, replyMsg)}
                  handleFeedbackPopup={handleFeedbackPopup}
                />
              ) : (
                <Box
                  sx={{
                    height: "40vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h6"
                    color="text.secondary"
                    sx={{ textAlign: "center", px: 2 }}
                  >
                    No Data Available
                  </Typography>
                </Box>
              )}
            </TabPanel>
          </TabContext>
        </Box>
      </Paper>
    </Box>
  );
};

export default MyFeedback;
